import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

//Auth Guard
import { AuthGuardComponent } from './auth-guard/auth-guard.component';

//main components
import { HomeComponent } from './home/home.component';
import { CombosComponent } from "./combos/combos.component";
import { RechargeComponent } from "./recharge/recharge.component";
import { SuspendLineEquipComponent } from "./suspend-line-equip/suspend-line-equip.component";
import { ActivationMenuComponent } from "./activation-menu/activation-menu.component";
import { ReleaseLineEquipComponent } from "./release-line-equip/release-line-equip.component";
import { CallLogDetailComponent } from './call-log-detail/call-log-detail.component';
import { ChangeNumberComponent } from "./change-number/change-number.component";
import { ChangeChipComponent } from "./change-chip/change-chip.component";
import { LoginComponent } from "./login/login.component";
import { MyAccountComponent } from './my-account/my-account.component';
import { OrderHistoryComponent } from './order-history/order-history.component';
import { CreateTicketComponent } from "./create-ticket/create-ticket.component"
import { PaymentViewUrlerrorComponent } from "./payment-view-urlerror/payment-view-urlerror.component";
import { PaymentViewUrlokComponent } from "./payment-view-urlok/payment-view-urlok.component";
import { PaymentViewUrlokRecurrentComponent } from './payment-view-urlok-recurrent/payment-view-urlok-recurrent.component';
import { PaymentViewUrlerrorRecurrentComponent } from './payment-view-urlerror-recurrent/payment-view-urlerror-recurrent.component';
import { EditUserInfoComponent } from "./edit-user-info/edit-user-info.component";
import { BalancesAndBoltonsComponent } from './balances-and-boltons/balances-and-boltons.component';
import { HelpComponent } from './help/help.component';
import { CoverageComponent } from './coverage/coverage.component';
import { ComboWizardComponent } from './combos/combo-wizard/combo-wizard.component';
import { HomologationComponent } from './homologation/homologation.component';
//import { MovistarPlayComponent } from './movistar-play/movistar-play.component';
import { NormativeComponent } from './normative/normative.component';
import { MapsCoverageComponent } from './maps-coverage/maps-coverage.component';
import { Uso911Component } from './uso911/uso911.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { FormPrivacyComponent } from './form-privacy/form-privacy.component';
import { WigdetPersonalDataComponent } from './wigdet-personal-data/wigdet-personal-data.component';
import { FormPersonalDataComponent } from './form-personal-data/form-personal-data.component';


const routes: Routes = [
  { path: '', component: HomeComponent },
  // Cambiarse a maxiplus
   { path: 'menu-activacion/:idTab', component: ActivationMenuComponent},
  // Comprar
  { path: 'combos', component: CombosComponent },
  { path: 'bonos', component: CombosComponent },
  { path: 'recargas', component: RechargeComponent},
  // Servicios
  { path: 'suspender-linea-equipo', component: SuspendLineEquipComponent, canActivate: [AuthGuardComponent]},
  { path: 'liberar-linea-equipo', component: ReleaseLineEquipComponent, canActivate: [AuthGuardComponent]},  
  { path: 'reposicion-de-chip', component: ChangeChipComponent, canActivate: [AuthGuardComponent]},
  { path: 'roaming', component: MyAccountComponent},
  { path: 'adelanto-de-saldo', component: MyAccountComponent},
   
  // Extras
  { path: 'su-cuenta', component: MyAccountComponent, canActivate: [AuthGuardComponent]},  
  { path: 'cambio-de-numero', component: ChangeNumberComponent, canActivate: [AuthGuardComponent]},
  { path: 'detalle-llamadas', component: CallLogDetailComponent, canActivate: [AuthGuardComponent]},
  { path: 'cambiar-numero', component: ChangeNumberComponent, canActivate: [AuthGuardComponent]},
  { path: 'inicio-sesion', component: LoginComponent},
  { path: 'historial-ordenes', component: OrderHistoryComponent, canActivate: [AuthGuardComponent]},
  { path: 'historial-ordenes/:isLast', component: OrderHistoryComponent, canActivate: [AuthGuardComponent]},
  { path: 'nueva-solicitud', component: CreateTicketComponent, canActivate: [AuthGuardComponent]}, 
  { path: 'editar-informacion', component: EditUserInfoComponent, canActivate: [AuthGuardComponent]},
  { path: 'ayuda', component: HelpComponent},
  { path: 'cobertura', component: CoverageComponent},
  { path: 'homologacion', component: HomologationComponent},
  //{ path: 'movistar-play', component: MovistarPlayComponent},
  { path: 'normativas', component: NormativeComponent},
  { path: 'privacy/:isLogin', component: PrivacyComponent },
  { path: 'uso911', component: Uso911Component},
  
  //payment sys DCP
  { path: 'error-pago/:errorMsg', component: PaymentViewUrlerrorComponent},  
  { path: 'confirmacion-pago/:msisdn/:rechargeAmount/:cCard/:authNumber/:txNumber/:txDate', component: PaymentViewUrlokComponent}, 

  //payment recurrent
  { path: 'error-pago-recurrente/:errorMsg', component: PaymentViewUrlerrorRecurrentComponent},  
  { path: 'confirmacion-pago-recurrente/:numberMaxi/:rechargeAmount/:cCard/:authNumber/:txNumber', component: PaymentViewUrlokRecurrentComponent}, 


  //maps-coverage
  { path: 'mapa-cobertura', component: MapsCoverageComponent},

  { path: 'compra-de-combos', component: ComboWizardComponent}, 
  
  //Saldos y consumos
  { path: 'consulta-saldos', component: BalancesAndBoltonsComponent, canActivate: [AuthGuardComponent] },

  //Formulario ejercicio de derechos
  { path: 'form-privacy', component: FormPrivacyComponent },
  //maps-coverage
  { path: 'widget', component: WigdetPersonalDataComponent},

  //Formulario aceptacion de datos personal
  { path: 'form-accept-terms', component: FormPersonalDataComponent }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
